import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { findSet, skipSet } from '../../store/filterSlice';
import { useTranslation } from 'react-i18next';
import './Search.css';
const MIN_SEARCH_SIZE = 3; // Минимальное число символов для поиска
//
// Компонент строки поиска по активностям мероприятия
//
const SearchActivities = () => {
	const { t } = useTranslation();
    const dispatch = useDispatch();
    const find = useSelector(state => state.filter.find);
    const [ input, setInput ] = useState(find); // содержимое строки поиска

    // Запуск полного поиска в основном окне
    // по нажатию Enter в строке или по клику на иконку поиска
    const doSearch = useCallback((input) => {
        dispatch(findSet(input.trim()));
        dispatch(skipSet(0));
    }, [ dispatch ]);

    // Мы хотим автоматически отправлять запрос на поиск после того, как пользователь закончил ввод.
    // Для этого используем для debouncing эту технику.
    useEffect(() => {
        const timeOutId = setTimeout(() => {
            const length = input.trim().length;
            if(length >= MIN_SEARCH_SIZE || length < 1) doSearch(input);
        }, 500);

        return () => clearTimeout(timeOutId);
    }, [ input, doSearch ]);

    // Проверка нажатия на Enter/Esc в строке поиска
    const onKeyDown = (e) => {
        if(e.key === 'Enter') {
            doSearch(input);
        } else if(e.key === 'Escape') {
            setInput('');
        }
    };

	return (
        <div className='Search'>
			<input
				type='text'
                value={input}
				onChange={e => setInput(e.target.value)}
                onKeyDown={e => onKeyDown(e)}
                placeholder={t('search.placeholder')}
			/>
            <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className='icon'
                style={{cursor:'pointer'}}
                onClick={() => doSearch(input)}
            />
        </div>
	);
};

export default SearchActivities;
